import { serviceName } from '../resources/serviceConstants';
import {
  MASTER_DEPARTMENT,
  MASTER_VERTICAL,
  MASTER_DESIGNATION,
  PERFORMANCE_PERIOD_DETAILS,
  LOST_DROPPED_STATUS,
  CONFERENCE_ROOM,
  STAFFING_GEOGRAPHY,
} from '../resources/endPoint';

export const departmentData = () => {
  return {
    url: MASTER_DEPARTMENT,
    method: 'get',
    headers: { 'content-type': 'application/json' },
    authRequired: false,
    csrfToken: true,
    service: serviceName.MASTER_MS,
  };
};

export const verticalData = () => {
  return {
    url: MASTER_VERTICAL,
    method: 'get',
    headers: { 'content-type': 'application/json' },
    authRequired: false,
    csrfToken: true,
    service: serviceName.MASTER_MS,
  };
};

export const conferenceData = () => {
  return {
    url: CONFERENCE_ROOM,
    method: 'get',
    headers: { 'content-type': 'application/json' },
    authRequired: false,
    csrfToken: true,
    service: serviceName.ACHIEVEMENTS_MS,
  };
};

export const designationData = () => {
  return {
    url: MASTER_DESIGNATION,
    method: 'get',
    headers: { 'content-type': 'application/json' },
    authRequired: false,
    csrfToken: true,
    service: serviceName.MASTER_MS,
  };
};

export const getLostOrDroppedReasonData = (statusName) => {
  return {
    url: `${LOST_DROPPED_STATUS}?status_name=${statusName}`,
    method: 'get',
    headers: { 'content-type': 'application/json' },
    authRequired: false,
    csrfToken: true,
    service: serviceName.MASTER_MS,
  };
};

export const performnacePeriodData = () => {
  return {
    url: PERFORMANCE_PERIOD_DETAILS,
    method: 'get',
    headers: { 'content-type': 'application/json' },
    authRequired: false,
    csrfToken: true,
    service: serviceName.PERFORMANCE_MS,
  };
};

export const getGeographyListData = (dealType) => {
  if (typeof dealType !== 'string' || !/^[a-zA-Z0-9_\- ]+$/.test(dealType)) {
    throw new Error('Invalid dealType parameter');
  }
  return {
    url: `${STAFFING_GEOGRAPHY}?type=${encodeURIComponent(dealType)}`,
    method: 'get',
    headers: { 'content-type': 'application/json' },
    authRequired: false,
    csrfToken: true,
    service: serviceName.MASTER_MS,
  };
};
